<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div class="">
    <page-header>
      区域设置
    </page-header>
    <div
      style="display: grid;
             grid-template-columns: repeat(6,minmax(0,1fr));
             grid-gap: 12px"
    >
      <v-card
        class="pa-4 d-flex align-center justify-center"
        color="#eee"
        elevation="0"
        @click="areaSettingDialog = true"
      >
        <v-icon large>
          mdi-plus
        </v-icon>
      </v-card>
      <v-card
        v-for="item in items"
        :key="item"
        elevation="0"
        width="100%"
      >
        <v-responsive :aspect-ratio="1">
          <div class="d-flex justify-center align-center">
            <div />
            <v-spacer />
            <v-menu
              close-on-content-click
              left
              offset-overflow
              offset-y
              rounded
            >
              <template #activator="{on,attrs}">
                <v-btn
                  icon
                  style="border-radius: 12px"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <v-list
                outlined
                width="200px"
              >
                <v-list-item-group>
                  <v-list-item>
                    <v-list-item-title @click="editArea(item)">
                      {{ $t('edit') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      {{ $t('delete') }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
          <div class="d-flex px-4 py-6 justify-center align-center">
            {{ item }}
          </div>
        </v-responsive>
      </v-card>
    </div>
    <v-dialog
      v-model="areaSettingDialog"
      max-width="400px"
    >
      <v-card class="pa-4">
        <div class="d-flex align-center justify-center">
          <div class="text-h4 font-weight-bold">
            新建区域
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="areaSettingDialog = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div
          class="d-flex align-center justify-center mt-8"
        >
          <div
            class="text-h5 font-weight-bold"
            style="width: 150px"
          >
            区域名字:
          </div>
          <v-text-field
            v-model="areaName"
            dense
            hide-details
            outlined
          />
        </div>
        <v-btn
          class="mt-8 mb-2 amber lighten-4"
          outlined
          width="100%"
          @click="saveArea"
        >
          保存
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageHeader from '@/views/widget/typography/PageHeader.vue'

export default {
  name: 'BrandingAreaSetting',
  components: { PageHeader },
  data () {
    return {
      editItem: null,
      areaName: '',
      areaSettingDialog: false,
      items: ['江苏', '湖北', '广东']
    }
  },
  methods: {
    saveArea () {
      this.items.push(this.areaName)
      this.areaSettingDialog = false
    },
    editArea (item) {
      this.areaName = item
      this.areaSettingDialog = true
    }
  }
}
</script>

<style scoped>

</style>
